import { useState } from 'react'

import { Box, Button } from '@factorialco/deprecated-design-system'

import Modal from 'modules/core/components/Modal'
import TextField from 'modules/core/components/TextField'
import i18n from 'modules/core/lib/i18n'

import { useValidation } from 'modules/trainings/hooks/useValidation'

export function NewLinkModal({
  description,
  onClose,
  onSubmit,
  title,
}: {
  description: string
  onClose: () => void
  onSubmit: (data: { url: string; title: string }) => Promise<unknown>
  title: string
}) {
  const [state, setState] = useState<{
    url: FieldValue
    status: 'idle' | 'submitting' | 'success' | 'error'
    title: FieldValue
  }>({
    url: { value: '' },
    status: 'idle',
    title: { value: '' },
  })
  const { validateLink } = useValidation()

  return (
    <Modal
      description={description}
      footer={
        <Button
          disabled={
            !!state.url.error ||
            !state.url.value.trim() ||
            !state.title.value.trim() ||
            state.status === 'submitting'
          }
          submit
        >
          {i18n.t('common.save')}
        </Button>
      }
      illustration="URL"
      onClose={onClose}
      onSubmit={async () => {
        try {
          setState((prev) => ({ ...prev, status: 'submitting', submitError: undefined }))
          await onSubmit({
            url: state.url.value,
            title: state.title.value,
          })
          setState((prev) => ({ ...prev, status: 'success' }))
        } catch (error) {
          setState((prev) => ({
            ...prev,
            status: 'error',
          }))
        }
      }}
      title={title}
    >
      <Box gap="s16">
        <TextField
          label={i18n.t('trainings.link_modal.fields.title')}
          mandatory
          onChange={(value) => setState((prev) => ({ ...prev, title: { value } }))}
          value={state.title.value}
        />
        <TextField
          error={state.url.dirty ? state.url.error : undefined}
          label={i18n.t('trainings.link_modal.fields.url')}
          mandatory
          onBlur={() => {
            setState((prev) => ({
              ...prev,
              url: {
                ...prev.url,
                dirty: true,
              },
            }))
          }}
          onChange={(value: string) => {
            setState((prev) => ({
              ...prev,
              url: {
                value,
                error: !value.trim()
                  ? i18n.t('trainings.link_modal.fields.required')
                  : validateLink(value),
              },
            }))
          }}
          placeholder={i18n.t('trainings.link_modal.fields.placeholder')}
          value={state.url.value}
        />
      </Box>
    </Modal>
  )
}

interface FieldValue {
  value: string
  error?: string
  dirty?: boolean
}
